import { useState } from "react";
import styled from "styled-components";
import { Colors } from "../../config";
import Button from "../../components/Button";
import ConfirmRequestTravellerDetails from "./ConfirmRequestTravellerDetails";
import CancelRequestModal from "../../components/ModalPages/CancelRequestModal";
import PriviledgeCardModal from "../../components/ModalPages/PriviledgeCardModal";
import RequestSuccessModal from "../../components/ModalPages/RequestSuccessModal";
import ErrorModal from "../../components/ErrorSuccessModal/ErrorModal";

const ConfirmRequestRightContainer = ({
  passengers,
  guests,
  formData,
  extraFields,
  onPrivilegeClubChange,
}) => {
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openPrivilegeModal, setOpenPrivilegeModal] = useState(false);
  const [openRequestSuccessModal, setOpenRequestSuccessModal] = useState('');
  const [errorMsg, setBackendErrorMsg] = useState({
    open: false,
    message: "",
  });
  return (
    <TravellerDetailsWrapper>
      <SecondColumnWrapper>
        <ConfirmRequestTravellerDetails
          passengers={passengers}
          guests={guests}
          formData={formData}
          extraFields={extraFields}
        />
        <ActionWrapper>
          <ButtonWrapper>
            <Button
              label="Cancel Request"
              bgColor={Colors.transparent}
              outlineColor={Colors.white}
              topBottomPadding="0.938rem"
              onClick={() => setOpenCancelModal(true)}
            />
            <Button
              label="Submit Request"
              bgColor={Colors.brandTwo}
              topBottomPadding="0.938rem"
              onClick={() => setOpenPrivilegeModal(true)}
            />
          </ButtonWrapper>
        </ActionWrapper>
      </SecondColumnWrapper>
      {openCancelModal && (
        <CancelRequestModal setClose={() => setOpenCancelModal(false)} />
      )}
      {openPrivilegeModal && (
        <PriviledgeCardModal
          setClose={() => setOpenPrivilegeModal(false)}
          setOpenRequestSuccessModal={setOpenRequestSuccessModal}
          passengers={passengers}
          onPrivilegeClubChange={onPrivilegeClubChange}
          onError={(err) =>
            setBackendErrorMsg({
              open: true,
              message: err.message,
            })
          }
        />
      )}
      {openRequestSuccessModal && <RequestSuccessModal id={openRequestSuccessModal}/>}
      {errorMsg.open && (
        <ErrorModal
          subheaderText={errorMsg.message}
          setClose={() => setBackendErrorMsg({ open: false, message: "" })}
          onButtonClick={() => setBackendErrorMsg({ open: false, message: "" })}
        />
      )}
    </TravellerDetailsWrapper>
  );
};

const TravellerDetailsWrapper = styled.div`
  width: 55%;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }

  @media only screen and (min-width: 769px) and (max-width: 1000px) {
    width: 100%;
  }
`;

const SecondColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media only screen and (max-width: 768px) {
    gap: 2.75rem;
  }
`;

const ActionWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 26rem;
  gap: 0.5rem;
  margin-bottom: 1rem;

  @media only screen and (max-width: 768px) {
    flex-direction: column-reverse;
    width: 100%;
    gap: 1rem;
  }
  @media only screen and (max-width: 1280px) {
    align-self: flex-end;
  }
`;

export default ConfirmRequestRightContainer;
